module.exports = __webpack_public_path__ + "7745950a0bccc270efc0dab9542dee49.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/index/images/youzhen_h.png
// module id = 273
// module chunks = 3